<template>
  <v-layout wrap justify-center>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <!-- <v-flex xs12 pb-lg-12 pb-5><v-divider></v-divider></v-flex> -->
    <v-flex xs10 md12 pb-lg-12 pb-5>
      <v-layout>
        <v-flex pt-3 pb-6 xs12 text-left>
          <span
            style="color: #000; font-size: 22px; font-family: poppinsbold"
            >{{ productDetail.name }}</span
          >
        </v-flex>
      </v-layout>
      <v-layout wrap class="RR">
        <v-flex
          xs12
          sm3
          md3
          lg2
          align-self-start
          v-if="productDetail.photo != null"
        >
          <div v-viewer style="display: flex">
            <span>
              <img
                style="object-fit: contain; cursor: pointer"
                :src="mediaURL + productDetail.photo"
                height="160px"
                width="160px"
                contain
              />
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm3 md3 lg2 pt-sm-6 align-self-start v-else>
          <v-img
            height="160px"
            width="160px"
            contain
            :src="require('./../../../assets/images/no-image.png')"
          >
          </v-img>
        </v-flex>
        <v-flex xs12 sm12 md6>
          <v-layout wrap>
            <v-flex xs12 sm12 md6 align-self-start>
              <v-layout wrap>
                <v-flex align-self-start text-left xs12 pt-3>
                  <b>Shop Name :</b> {{ $route.query.shop }}
                </v-flex>
                <v-flex align-self-start text-left xs12 pt-2>
                  <b>Type :</b> {{ productDetail.type }}
                </v-flex>
                <v-flex
                  v-if="productDetail.categoryId"
                  align-self-start
                  text-left
                  xs12
                  pt-2
                >
                  <b>Category :</b> {{ productDetail.categoryId.name }}
                </v-flex>

                <v-flex
                  v-if="productDetail.preparationTime"
                  xs12
                  pt-2
                  align-self-start
                  text-left
                >
                  <span>
                    <b> Preparation Time :</b>
                    {{ getTimeFromMins(productDetail.preparationTime) }}
                  </span>
                </v-flex>
                <v-flex
                  xs12
                  pt-2
                  align-self-start
                  text-left
                  v-if="productDetail.isAllTime"
                >
                  <span>
                    <b> Product Availability:</b>
                    24 x 7
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md6 align-self-start>
              <v-layout wrap>
                <v-flex xs12 pt-2 align-self-start text-left>
                  <span>
                    <b>Rs.</b> {{ Number(productDetail.offerPrice).toFixed(2) }}
                  </span>
                  <span v-if="productDetail.price != productDetail.offerPrice">
                    <del
                      ><b>Rs.</b>
                      {{ Number(productDetail.price).toFixed(2) }}</del
                    ></span
                  >
                </v-flex>
                <v-flex
                  v-if="productDetail.maxOrderQuantity"
                  xs12
                  pt-2
                  align-self-start
                  text-left
                >
                  <span>
                    <b>Max. Order Quantity :</b>
                    {{ productDetail.maxOrderQuantity }}
                  </span>
                </v-flex>
                <v-flex xs12 pt-2 align-self-start text-left>
                  <span>
                    <b>Packing Charge :</b>
                    {{ productDetail.packingCharge }}
                  </span>
                </v-flex>

                <v-flex xs12 pt-2 align-self-start text-left>
                  <span v-if="productDetail.commissionType == 'percentage'">
                    <b>Commission Percentage :</b>
                    {{ productDetail.commissionPercentage }}%
                  </span>
                  <span v-else>
                    <b>Commission Price :</b>
                    {{ Number(productDetail.commission).toFixed(2) }}
                  </span>
                </v-flex>
                <v-flex xs12 pt-2 align-self-start text-left>
                  <v-btn
                    v-if="productDetail.isPreOrderOnly == true"
                    elevation="0"
                    small
                    dark
                    dense
                    style="cursor: none"
                  >
                    Pre Order Only</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 text-left>
              <v-rating
                readonly
                :value="productDetail.rating"
                color="yellow darken-3"
                background-color="grey "
                empty-icon="$ratingFull"
                half-increments
                hover
              ></v-rating>
            </v-flex>
            <v-flex pt-3 xs12 sm12 text-left pb-3>
              <v-layout wrap>
                <v-flex xs6 sm4 md3 py-2 text-left>
                  <span class="pr-2">
                    <v-btn
                      depressed
                      small
                      color="info"
                      @click="
                        $router.push(
                          '/editProduct?id=' +
                            productDetail._id +
                            '&seller=' +
                            productDetail.sellerId.uid
                        )
                      "
                      >Update</v-btn
                    >
                  </span>
                </v-flex>
                <v-flex xs6 sm4 md3 py-2 text-left>
                  <span class="pl-2">
                    <v-btn
                      color="red"
                      depressed
                      small
                      @click="deleteDialog = true"
                    >
                      <span style="color: #fff">Remove</span></v-btn
                    >
                  </span>
                </v-flex>
                <v-flex xs6 sm4 md3 py-2 text-left>
                  <span v-if="productDetail.status == 'Inactive'">
                    <v-btn color="green" @click="statusDialog = true" small
                      ><span style="color: #fff">Enable </span>
                    </v-btn>
                  </span>
                  <span v-if="productDetail.status == 'Active'">
                    <v-btn color="red" @click="statusDialog = true" small
                      ><span style="color: #fff">Disable </span>
                    </v-btn>
                  </span>
                </v-flex>
                <v-flex xs6 sm4 md3 py-2 text-left>
                  <span v-if="productDetail.isPromoted == false">
                    <v-btn color="info" @click="promoteDialog = true" small
                      ><span style="color: #fff">Promote </span>
                    </v-btn>
                  </span>
                  <span v-if="productDetail.isPromoted == true">
                    <v-btn color="green" @click="promoteDialog = true" small
                      ><span style="color: #fff">Demote </span>
                    </v-btn>
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 sm4 md3 lg4>
          <v-layout wrap justify-center>
            <v-flex xs6 pr-1 v-if="productDetail.productPhoto != null">
              <div v-viewer style="display: flex">
                <span>
                  <img
                    style="object-fit: contain; cursor: pointer"
                    :src="mediaURL + productDetail.productPhoto"
                    height="160px"
                    width="160px"
                    contain
                  />
                </span>
              </div>
            </v-flex>
            <v-flex xs6 pl-1 v-if="productDetail.packedPhoto">
              <div v-viewer style="display: flex">
                <span>
                  <img
                    style="object-fit: contain; cursor: pointer"
                    :src="mediaURL + productDetail.packedPhoto"
                    height="160px"
                    width="160px"
                    contain
                  />
                </span>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          text-left
          v-if="productDetail.benefits"
          style="font-family: robotomedium"
        >
          BENEFITS
        </v-flex>
        <v-flex
          text-left
          v-if="productDetail.benefits"
          xs12
          class="text"
          align-self-end
        >
          {{ productDetail.benefits }}
        </v-flex>

        <v-flex text-left pt-3 style="font-family: robotomedium">
          DESCRIPTION
        </v-flex>
        <v-flex pb-5 text-left xs12 class="text">
          <v-layout>
            <span v-if="productDetail.description">{{
              productDetail.description
            }}</span>
          </v-layout>
          <v-layout>
            <span v-if="productDetail.ingredients"
              >Ingredients: {{ productDetail.ingredients }}</span
            >
          </v-layout>
          <v-layout>
            <span v-if="productDetail.servesFor"
              >Serves For: {{ productDetail.servesFor }} persons</span
            >
          </v-layout>
          <v-layout>
            <span v-if="productDetail.allergens"
              >Allergic Products:
              <span v-for="(items, i) in productDetail.allergens" :key="i">
                {{ items }}
                <span v-if="i != productDetail.allergens.length - 1"
                  >,</span
                ></span
              ></span
            >
          </v-layout>
          <v-layout>
            <span v-if="productDetail.suitableForDiabetic"
              >Suitable for diabetic Patients</span
            >
            <span v-else>Not suitable for diabetic Patients</span>
          </v-layout>
          <!-- {{ productDetail.description }} -->
        </v-flex>
        <v-flex xs12 text-left>
          <v-layout wrap>
            <!-- <v-flex xs12 style="font-family: robotomedium"> VARIANTS </v-flex> -->

            <v-flex xs12>
              <v-card class="mb-2">
                <v-layout pa-5 wrap v-for="(item, i) in variants" :key="i">
                  <v-flex
                    xs12
                    pt-2
                    align-self-start
                    text-center
                    style="
                      background-color: grey;
                      font-size: 20px;
                      border-radius: 20px;
                    "
                    class="white--text"
                  >
                    <span>
                      <b>Variant {{ i + 1 }}</b>
                    </span>
                  </v-flex>

                  <v-flex xs12 pt-2 align-self-start text-left>
                    <span>
                      <b>Description :</b>
                      {{ item.varientDescription }}
                    </span>
                  </v-flex>
                  <v-flex xs12 pt-2 align-self-start text-left>
                    <span>
                      <b>Price :</b>
                      {{ item.varientPrice }}
                    </span>
                  </v-flex>
                  <v-flex xs12 pt-2 align-self-start text-left>
                    <span v-if="item.foodType == 'food'">
                      <b>Portion:</b>
                      {{ item.portion }}
                    </span>
                    <span v-if="item.foodType == 'cake'">
                      <b>Weight:</b>
                      {{ item.weight }}
                    </span>
                    <span v-if="item.foodType == 'others'">
                      <b>Crusts:</b>
                      {{ item.crusts }}
                    </span>
                  </v-flex>
                  <v-flex xs12 pt-2 align-self-start text-left>
                    <span>
                      <b>Serve For :</b>
                      {{ item.varientServeFor }}
                    </span>
                  </v-flex>
                  <v-flex xs12 pt-2 align-self-start text-left>
                    <span>
                      <b>commissionPercentage :</b>
                      {{ item.commissionPercentage }} %
                    </span>
                  </v-flex>
                  <!-- <v-flex xs12 pb-4>
              <v-divider></v-divider>
            </v-flex> -->
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 v-if="addons.length > 0">Add On</v-flex>

            <v-flex xs12 text-left>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4
                  lg3
                  v-for="(item, i) in addons"
                  :key="i"
                  px-1
                  py-2
                >
                  <v-card>
                    <v-layout wrap pa-3 text-left>
                      <v-flex xs6> Name: </v-flex>
                      <v-flex xs6>
                        {{ item.addOnName }}
                      </v-flex>
                      <v-flex xs6> Price: </v-flex>
                      <v-flex xs6>
                        {{ item.addOnPrice }}
                      </v-flex>
                      <template>
                        <v-flex xs6> Quantity: </v-flex>
                        <v-flex xs6>
                          {{ item.addOnqQantity }}
                        </v-flex>
                      </template>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          v-if="
            productDetail.availableTimings &&
            productDetail.availableTimings.length > 0 &&
            !productDetail.isAllTime
          "
          pb-8
          xs12
          sm8
          md9
        >
          <v-layout wrap>
            <v-flex xs12 pt-4 text-left>
              <span style="color: #000">Availbale Timings</span>
            </v-flex>
            <v-flex xs12 pt-3>
              <v-card class="pt-2" :elevation="1" tile color="#FAFAFA">
                <v-layout py-2>
                  <v-flex xs2 text-center>
                    <span style="color: #555d50"> start Time </span>
                  </v-flex>
                  <v-flex xs2 text-center>
                    <span style="color: #555d50"> End Time </span>
                  </v-flex>
                  <v-flex xs8 text-center>
                    <span style="color: #555d50"> Days </span>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-divider></v-divider>
                </v-layout>

                <v-layout
                  py-2
                  v-for="(item, index) in productDetail.availableTimings"
                  :key="index"
                >
                  <v-flex xs4 sm2 text-center>
                    <span style="color: #000">
                      {{ formatTime(item.start) }}
                    </span>
                  </v-flex>
                  <v-flex xs4 sm2 text-center>
                    <span style="color: #000">
                      {{ formatTime(item.end) }}
                    </span>
                  </v-flex>
                  <v-flex xs4 sm8 text-center>
                    <span
                      style="font-size: 14px"
                      v-for="(item1, index1) in item.availableDays"
                      :key="index1"
                    >
                      {{ item1 }}
                      <span v-if="index1 != item.availableDays.length - 1">
                        ,</span
                      >
                    </span>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md12 px-lg-0 pb-12 px-2 text-left>
          <v-card color="#FAFAFA" tile>
            <v-layout wrap px-3 py-4 pa-sm-12 justify-start>
              <v-flex xs12 md6>
                <v-layout wrap>
                  <v-flex v-if="sellers.sellerId" xs12 pb-2 text-left>
                    <span><v-icon>mdi-account-outline</v-icon></span
                    ><span style="margin-left: 1%" class="RR">{{
                      sellers.sellerId.contactPerson
                    }}</span>
                  </v-flex>
                  <v-flex v-if="sellers.uid" xs12 pb-2>
                    <span><v-icon>mdi-phone-outline</v-icon></span>
                    <span class="RR" style="margin-left: 1%">{{
                      sellers.uid.phone
                    }}</span>
                    <!-- <span class="RR" style="margin-left: 3%"
                        >+91 4839 333 333</span
                      > -->
                  </v-flex>
                  <v-flex v-if="sellers.sellerId" xs12 pb-2>
                    <span><v-icon>mdi-at</v-icon></span>
                    <span class="RR" style="margin-left: 1%">{{
                      sellers.sellerId.email
                    }}</span>
                  </v-flex>
                  <v-flex v-if="sellers.sellerId" xs12 pb-2>
                    <span><v-icon>mdi-map-marker-outline</v-icon></span>
                    <span class="RR" style="margin-left: 1%"
                      >{{ sellers.sellerId.city }},
                      {{ sellers.sellerId.place }}</span
                    >
                  </v-flex>
                  <!-- <v-flex xs12 text-left>
              <v-layout wrap>
                <v-flex xs6 sm3 md5 lg3
                  ><v-rating
                    :value="parseInt(productDetail.rating)"
                    color="amber"
                    background-color="#C7BCBC"
                    half-increments
                    length="5"
                    readonly
                    size="14"
                  ></v-rating>
                </v-flex>
                <v-flex pl-lg-5 xs6 align-self-center>
                  <span>{{ productDetail.totalReviews }} Reviews</span>
                </v-flex>
              </v-layout>
            </v-flex> -->
                </v-layout>
              </v-flex>

              <v-flex xs12 md6>
                <v-layout wrap>
                  <v-flex xs12 align-self-center>
                    <span style="font-family: poppinsbold">Bank Details</span>
                  </v-flex>
                  <v-flex v-if="sellers.sellerId" xs12 py-2 text-left>
                    <span class="RR"><b> Account Holder :</b> </span
                    ><span style="margin-left: 1%" class="RR">{{
                      sellers.sellerId.bankDetails.accountHolder
                    }}</span>
                  </v-flex>
                  <v-flex v-if="sellers.sellerId" xs12 pb-2 text-left>
                    <span class="RR"><b> Account Number : </b> </span
                    ><span style="margin-left: 1%" class="RR">{{
                      sellers.sellerId.bankDetails.accountNo
                    }}</span>
                  </v-flex>
                  <v-flex v-if="sellers.sellerId" xs12 pb-2 text-left>
                    <span class="RR"><b> Bank : </b> </span
                    ><span style="margin-left: 1%" class="RR">{{
                      sellers.sellerId.bankDetails.bank
                    }}</span>
                  </v-flex>
                  <v-flex v-if="sellers.sellerId" xs12 pb-2 text-left>
                    <span class="RR"><b> Branch : </b></span
                    ><span style="margin-left: 1%" class="RR">{{
                      sellers.sellerId.bankDetails.branch
                    }}</span>
                  </v-flex>
                  <v-flex v-if="sellers.sellerId" xs12 pb-2 text-left>
                    <span class="RR"><b> IFSC :</b> </span
                    ><span style="margin-left: 1%" class="RR">{{
                      sellers.sellerId.bankDetails.ifsc
                    }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- <v-flex xs12 md6 class="align-center RR" text-center>
                  <div>
                    No. Of <br />
                    apiaries
                  </div>
                  <div class="headds">
                    {{ sellers.sellerId.apiaryCount }}
                  </div>
                </v-flex> -->
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- <v-flex xs12 v-if="productDetail.uid">
      <Review v-bind:id="productDetail.uid._id" />
    </v-flex> -->

    <!-- <v-flex xs12>
      <v-divider></v-divider>
      <v-flex
        xs12
        align-self-center
        v-if="productDetail.productStatus == 'Pending'"
      >
        <v-layout wrap justify-center pa-4>
          <v-flex xs6 sm4 md3 lg2 px-2 text-left>
            <v-btn
              small
              width="100%"
              color="primary"
              @click="verifyStatus('approve')"
              >APPROVE</v-btn
            >
          </v-flex>
          <v-flex xs6 sm4 md3 lg2 px-2 text-right>
            <v-btn
              small
              width="100%"
              color="error"
              @click="verifyStatus('reject')"
              >REJECT</v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex> -->
    <!-- <v-flex xs12>
      <Similarproduct />
    </v-flex> -->

    <!-- verify  -->

    <v-dialog persistent v-model="verifyDelete" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="#ffffff" v-on="on" v-bind="attrs">mdi-delete</v-icon>
      </template>
      <v-card>
        <v-card-title>{{ notice }}</v-card-title>
        <v-card-title>
          <v-layout wrap v-if="isReject">
            <v-flex xs12 pa-40>
              <v-form v-model="validates" ref="form">
                <v-textarea
                  outlined
                  color="warning"
                  name="input-7-4"
                  v-model="reason"
                  :rules="[req.required]"
                  label="Enter the remarks"
                ></v-textarea>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="(verifyDelete = false), (isReject = false), (reason = '')"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!validates && isReject"
            color="primary"
            text
            @click="updateStatus(keepStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title
          >Are you sure you want to remove this product</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="statusDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title v-if="productDetail.status == 'Active'"
          >Are you sure you want to disable this Product?</v-card-title
        >
        <v-card-title v-if="productDetail.status == 'Inactive'"
          >Are you sure you want to enable this Product?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="statusDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeStatus()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="promoteDialog" max-width="600px">
      <v-card>
        <!-- <v-card-title text-center v-if="productDetail.status == 'Active'"
          >Are you sure you want to disable this Product?</v-card-title
        > -->
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 py-3>
              <span style="font-family: poppinsregular">
                <b> Promote This Product by uploading Image </b>
              </span>
            </v-flex>
            <v-flex xs12>
              <ImageComp
                style="font-family: poppinsregular"
                @stepper="winStepper"
                typr
                :height="1.5"
                :width="1"
                :heading="'Upload  Image *'"
                :componentType="'promoteImage'"
                :singleImage="productDetail.offerImage"
              />
              <!-- :singleImage="productData.photo" -->
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="promoteDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            v-if="productDetail.isPromoted == false"
            text
            @click="promoteProduct()"
            >Save</v-btn
          >

          <v-btn color="blue darken-1" v-else text @click="DemoteProduct()"
            >Demote</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import axios from "axios";
import ImageComp from "@/components/Common/singleImage";
// import moment from "moment"
// import Review from "./customerReview";
// import Similarproduct from "./similarProduct";
export default {
  components: {
    ImageComp,
    // Review,
    // Similarproduct,
  },
  data() {
    return {
      pform: new FormData(),

      productPromotionSwitch: false,
      promoteDialog: false,
      promotionImage: null,
      variants: [],
      addons: [],
      items: ["f2", "f1", "f3"],
      kg: "",
      productDetail: [],
      sellers: [],
      qty: 1,
      newprice: 0,
      verifyDelete: false,
      keepStatus: "",
      notice: "",
      isReject: false,
      validates: false,
      reason: "",
      appLoading: false,
      req: {
        required: (value) => !!value || "Required.",
      },
      deleteDialog: false,
      statusDialog: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "promoteImage") {
        this.promotionImage = window_data.selectedFiles;
      }
      if (window_data.getData) this.getItem();
    },

    promoteProduct() {
      this.appLoading = true;

      this.pform.append("productId", this.$route.query.product);

      this.pform.append("offerImage", this.promotionImage);
      axios({
        method: "POST",
        url: "/add/remove/products/suggestion/list",
        headers: {
          token: localStorage.getItem("token"),
        },

        data: this.pform,
      }).then((response) => {
        if (response.data.status) {
          this.promoteDialog = false;
          this.getData();
          (this.pform = new FormData()), console.log(this.products);
        } else {
          (this.pform = new FormData()), (this.appLoading = false);
          this.showSnackBar = true;
          this.msg = response.data.msg;
          console.log("no data ");
        }
      });
    },

    DemoteProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/product/suggestion/remove",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          productId:this.$route.query.product
        },
      }).then((response) => {
        if (response.data.status) {
          this.promoteDialog = false;
          this.getData();
          console.log(this.products);
        } else {
          this.appLoading = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
          console.log("no data ");
        }
      });
    },

    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/admin/seller/product/view/" + this.$route.query.product,
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.productDetail = response.data.data;
          this.sellers = response.data.data;
          this.variants = response.data.data.varientIds;
          this.addons = response.data.data.addOnIds;
          this.appLoading = false;
          console.log(this.products);
        } else {
          this.appLoading = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
          console.log("no data ");
        }
      });
    },
    deleteItem() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/delete/" + this.$route.query.product,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", {
              getData: true,
            });
            this.deleteDialog = false;

            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.$router.go(-1);
          } else {
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
    verifyStatus(status) {
      this.verifyDelete = true;
      this.keepStatus = status;
      if (status == "approve")
        this.notice = "Do you want to approve this request?";
      else if (status == "reject") {
        this.isReject = true;
        this.notice = "Do you want to reject this request?";
      }
    },
    updateStatus(status) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/approve/reject",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.product,
          action: status,
          rejectReason: this.reason,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.getData();
            this.verifyDelete = false;
            this.$router.push("ProductList");
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    changeStatus() {
      this.loading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/status/change/" + this.$route.query.product,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.getData();
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    getTimeFromMins(mins) {
      var num = mins;
      if (num >= 60) {
        var hours = num / 60;
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);

        return rhours + " hour(s) and " + rminutes + " minute(s).";
      } else return num + " minutes";
    },
  },
};
</script>